import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { UserService, ThemeService } from '@app/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})

export class AppComponent implements AfterViewInit, OnInit {

	constructor(public userService: UserService,
	            translate: TranslateService,
	            private elementRef: ElementRef,
	            private themeService: ThemeService) {
		translate.addLangs(['pt-br']);
		translate.setDefaultLang('pt-br');
		translate.use('pt-br');
	}

	public ngOnInit(): void {
		this.themeService.initTheme();
	}

	public ngAfterViewInit() {
		this.elementRef.nativeElement.removeAttribute('ng-version');
	}

}
